import React, { useState, useEffect } from "react";
import Moment from "moment";

// Redux
import { connect } from "react-redux";

import PropTypes from "prop-types";
import genericAction from "@Actions/generic";

// Components
import Text from "@Components/Text";
import { Button, Checkbox, Dropdown, Form, Label, Icon, Grid } from "semantic-ui-react";
import Input from "@Components/Input";
import { dropdownFormat } from "@Utils/formats";
import IKModal from "@Components/IkModal";
import InputFilter from "@Components/InputFilter";

// Lodash
import { isEmpty, map, concat, split } from "lodash";
// Modals
// import InputContactFilter from "@Components/InputContactFilter";
import TextareaAutosize from "react-textarea-autosize";

// staticData
import { contactOption } from "./staticData";

// Styles
import styles from "./styles.module.css";

const ActionUserCrud = ({
	onClose,
	platforms,
	dispatch,
	setPlatformfilters,
	groupsfilters,
	setGroupsfilters,
	tagsSelected,
	setTagsSelected,
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	contacts,
	setContacts,
	agents,
	setAgents,
	note,
	setNote,
	options,
	setSeletedFilteres,
	seletedFilteres,
	dateField,
	setDateField,
	onApplyFilters,
	channelFilters,
	setChannelFilters,
	channels,
}) => {
	const [platformfiltersData, setPlatformfiltersData] = useState([]);
	const [platformAll, setPlatformAll] = useState(false);
	const [groupsAll, setGroupsAll] = useState(false);
	const [groupsData, setGroupsData] = useState([]);
	const [agentsData, setAgentsData] = useState("");
	const [tagsData, setTagsData] = useState("");
	const [cleaned, setCleaned] = useState(false);
	const [filtersByReportType, setFiltersByReportType] = useState({});
	const [selectedFilterTemp, setSelectedFilterTemp] = useState(seletedFilteres || "Primera Respuesta");

	const [errors, setErrors] = useState({ platformfilters: "", selected: "" });

	useEffect(() => {
		(async () => {
			const usersPromise = dispatch(genericAction({ method: "get", route: "users/all" }));
			const tagsPromise = dispatch(genericAction({ method: "get", route: "tags/all" }));
			const groupPromise = dispatch(genericAction({ method: "get", route: "groups/all" }));
			const [usersResponse, tagsResponse, groupResponse] = await Promise.all([usersPromise, tagsPromise, groupPromise]);
			const platoformsMapped = map(platforms, (item) => {
				return {
					key: item.id,
					text: item.name.toLowerCase(),
					icon: item.name.toLowerCase(),
					value: item.id,
				};
			});

			const groupsMapped = dropdownFormat(groupResponse, "name", "id");
			const agentsMapped = dropdownFormat(usersResponse, "user.fullName", "userId");
			const tagsMapped = dropdownFormat(tagsResponse, "name", "id");
			groupsMapped.unshift({ key: "*", text: "Sin grupo", value: "*" });
			setGroupsData(groupsMapped);

			setPlatformfiltersData(platoformsMapped);
			setAgentsData(agentsMapped);
			// setContacts(contactsMapped);
			setTagsData(tagsMapped);
		})();
	}, []);

	const checkAll = (name) => {
		switch (name) {
			case "platformfilters":
				if (!platformAll) {
					const allChannelIds = map(platforms, (item) => {
						return item.id;
					});
					setChannelFilters(allChannelIds);
					setPlatformAll(true);
				} else {
					setChannelFilters([]);
					setPlatformAll(false);
				}
				break;
			case "groupsfilters":
				if (!groupsAll) {
					const allGroupIds = map(groupsData, (item) => {
						return item.value;
					});
					setGroupsfilters(allGroupIds);
					setGroupsAll(true);
				} else {
					setGroupsfilters([]);
					setGroupsAll(false);
				}
				break;
			default:
				break;
		}
	};

	const handleInput = (e) => {
		const { name, value } = e.target;
		if (name === "startDate") {
			setStartDate(value);
		} else {
			setEndDate(value);
		}
	};

	const handleTipyfication = (name, data) => {
		setTagsSelected(data);
	};

	const onFilter = () => {
		const contactId = contacts?.id || null;
		const errorsTest = {};

		const noFieldsSelected =
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters) &&
			isEmpty(selectedFilterTemp);

		const onlyReportType =
			!isEmpty(selectedFilterTemp) &&
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters);

		if (noFieldsSelected) {
			errorsTest.selected = "Debe seleccionar mínimo un campo";
			setErrors(errorsTest);
			return;
		}

		if (onlyReportType) {
			errorsTest.selected = "Seleccione al menos otro campo además del tipo de reporte";
			setErrors(errorsTest);
			return;
		}

		if (isEmpty(selectedFilterTemp)) {
			errorsTest.selected = "Debe seleccionar un tipo de reporte";
			setErrors(errorsTest);
			return;
		}

		setErrors({});
		const filters = {};

		if (contactId) filters.contactId = contactId;
		if (!isEmpty(agents)) {
			filters["userId[]"] = concat([], agents);
		}
		if (!isEmpty(groupsfilters)) {
			if (groupsfilters.includes("*")) {
				filters["groupId&*"] = 0;
			} else {
				filters["groupId[]"] = concat([], groupsfilters);
			}
		}

		if (!isEmpty(tagsSelected)) filters.tags = tagsSelected;
		if (note) filters.text = note;
		if (!isEmpty(channelFilters)) {
			filters["channelId[]"] = concat([], channelFilters);
			filters["chat.channelId[]"] = concat([], channelFilters);
		}
		if (dateField && (startDate || endDate)) {
			const start = startDate || "";
			const end = endDate || "";
			filters[dateField] = `${start},${end}`;
		}

		setFiltersByReportType((prev) => {
			return {
				...prev,
				[selectedFilterTemp]: filters,
			};
		});

		if (onApplyFilters) {
			setSeletedFilteres(selectedFilterTemp);
			onApplyFilters(filters);
		}
		onClose();
	};

	useEffect(() => {
		const filters = filtersByReportType[selectedFilterTemp];
		if (filters) {
			setAgents(filters["userId[]"] || filters.userId || []);
			setContacts(filters.contactId ? { id: filters.contactId } : {});
			setGroupsfilters(filters["groupId[]"] || filters.groups || []);
			setTagsSelected(filters.tags || []);
			setNote(filters.text || "");
			setPlatformfilters(filters.platforms || []);
			setChannelFilters(filters["channelId[]"] || filters["chat.channelId[]"] || []);

			if (filters.createdDate || filters.closeDate) {
				const range = filters.createdDate || filters.closeDate;
				const [start, end] = split(range, ",");
				setStartDate(start);
				setEndDate(end);
				setDateField(filters.createdDate ? "createdDate" : "closeDate");
			}
		}
	}, [selectedFilterTemp]);

	const onChangeDropdown = (value, name) => {
		if (name === "platformfilters") {
			setPlatformfilters(value);
			if (platformfiltersData.length === value.length) {
				setPlatformAll(true);
			} else {
				setPlatformAll(false);
			}
		} else if (name === "groupsfilters") {
			setGroupsfilters(value);
			if (groupsData.length === value.length) {
				setGroupsAll(true);
			} else {
				setGroupsAll(false);
			}
		}
	};

	const onContactsSelect = (item) => {
		setContacts(item);
	};
	const onContactsRemove = () => {
		setContacts({});
	};
	const renderLabelPlatforms = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const renderLabelDepartments = (label) => {
		return {
			color: "blue",
			content: `${label.text} `,
			icon: "building outline",
		};
	};
	const cleanModal = () => {
		setAgents([]);
		setContacts("");
		setPlatformfilters([]);
		setChannelFilters([]);
		setGroupsfilters([]);
		setTagsSelected([]);
		setStartDate("");
		setEndDate("");
		setNote("");
		setGroupsAll(false);
		setPlatformAll(false);
		setErrors({ platformfilters: "", selected: "" });
		setSeletedFilteres("");
		setSelectedFilterTemp("Primera Respuesta");
		setCleaned(true);

		setTimeout(() => {
			setCleaned(false);
		}, 2000);
	};

	const handleInputDropdown = (event, { value }) => {
		setTagsSelected(value);
	};

	const onChangeSelection = (e, { value }) => {
		setSelectedFilterTemp(value);
		if (value === "Resumidas" || value === "Hora/Usuarios" || value === "Hora/Grupos") {
			setTagsSelected([]);
			setNote("");
		}
	};

	const channelOptions = map(channels, (channel) => {
		return {
			key: channel.id,
			text: channel.label,
			value: channel.id,
			icon: channel.platform?.name?.toLowerCase() || "circle",
		};
	});

	const handleChannelChange = (e, { value }) => {
		setChannelFilters(value);
	};

	return (
		<IKModal
			iconName="filter"
			title="Filtro de Conv. Tiempos"
			onClose={onClose}
			onSuccess={onFilter}
			cancelLabel="Cancelar"
			saveLabel="Filtrar"
			fullHeight
			size="small">
			<Grid className={styles.grid}>
				{!isEmpty(errors.selected) && (
					<div className={styles.center}>
						<Label className={styles.labelError} basic color="red">
							{errors.selected}
						</Label>
					</div>
				)}
				<div className={styles.containerFirst}>
					<fieldset className={styles.fieldset}>
						<legend className={styles.legendWithButton}>
							<span className={styles.legend}>Filtrado</span>
							<div className={styles.clearButtonContainer}>
								<Button icon size="mini" onClick={cleanModal} className={styles.clearButtonInline}>
									<Icon name="trash alternate outline" />
									Limpiar Todo
								</Button>
								{cleaned && <span className={styles.tooltipAbove}>¡Filtros limpiados!</span>}
							</div>
						</legend>

						<div className={styles.dateContent}>
							<div className={styles.dateFieldDate}>
								<div className={styles.userDropdownBlock2}>
									<span className={styles.lookUpLabel}>Tipo de Reporte:</span>
									<Dropdown
										className={styles.filterDropdown}
										placeholder="Selecciona un filtro"
										selection
										options={options}
										value={selectedFilterTemp}
										onChange={onChangeSelection}
									/>
								</div>
								<div className={styles.userDropdownBlock2}>
									<span className={styles.lookUpLabelSpecial}>Tipo:</span>
									<Dropdown
										className={styles.filterDropdown}
										placeholder="Selecciona el tipo de fecha"
										selection
										options={[
											{ key: "closeDate", text: "F. Cierre", value: "closeDate" },
											{ key: "createdDate", text: "F. Entrada", value: "createdDate" },
										]}
										value={dateField || "closeDate"}
										onChange={(e, { value }) => {
											setDateField(value);
										}}
									/>
								</div>
								<div className={styles.flexContainer}>
									<Input
										type="date"
										label="Desde:"
										icon="calendar minus"
										iconPosition="left"
										placeholder="Inicio"
										fluid
										size="mini"
										name="startDate"
										value={startDate}
										max={Moment().format("YYYY-MM-DD")}
										onChange={handleInput}
										className={styles.dateInput}
									/>
									<Input
										type="date"
										label="Hasta:"
										icon="calendar plus"
										iconPosition="left"
										placeholder="Final"
										fluid
										size="mini"
										name="endDate"
										value={endDate}
										min={startDate}
										max={Moment().format("YYYY-MM-DD")}
										onChange={handleInput}
										className={styles.dateInput}
									/>
								</div>
							</div>
						</div>
					</fieldset>
					<fieldset className={styles.fieldset}>
						<legend className={styles.legend}>Otros</legend>
						<div className={styles.contactContainer}>
							<div className={styles.lookUpLabel}>Contacto:</div>
							<InputFilter
								contactData={contacts}
								selectedContact={onContactsSelect}
								onEmpty={onContactsRemove}
								url="contacts"
								defaultField="all"
								forceInputValue="name"
								selectTitle="Buscar Contacto"
								tableColumns={contactOption}
							/>
						</div>
						<div className={styles.userContainerTags}>
							<div
								className={`${styles.userDropdownBlock} ${styles.typification} ${
									selectedFilterTemp === "Resumidas" ? styles.resumidasCompact : ""
								} ${selectedFilterTemp === "Hora/Usuarios" ? styles.resumidasCompact : ""} ${
									selectedFilterTemp === "Hora/Grupos" ? styles.resumidasCompact : ""
								} ${selectedFilterTemp === "Por Días" ? styles.resumidasCompact : ""} ${
									selectedFilterTemp === "Por Horas" ? styles.resumidasCompact : ""
								}`}>
								<Text className={styles.lookUpLabel}>Usuarios:</Text>
								<Dropdown
									fluid
									onChange={(e, { value }) => {
										return setAgents(value);
									}}
									value={agents}
									renderLabel={renderLabelPlatforms}
									multiple
									selection
									search
									options={agentsData}
								/>
							</div>
							{selectedFilterTemp !== "Resumidas" &&
								selectedFilterTemp !== "Hora/Usuarios" &&
								selectedFilterTemp !== "Hora/Grupos" &&
								selectedFilterTemp !== "Por Días" &&
								selectedFilterTemp !== "Por Horas" && (
									<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
										<Text className={styles.lookUpLabel}>Etiquetas:</Text>
										<Dropdown
											fluid
											name="tagsSelected"
											value={tagsSelected}
											onChange={handleInputDropdown}
											options={tagsData}
											handleSelection={handleTipyfication}
											size="mini"
											search
											multiple
											selection
											selected
											renderLabel={renderLabelPlatforms}
										/>
									</div>
								)}
						</div>
						{selectedFilterTemp !== "Resumidas" &&
							selectedFilterTemp !== "Hora/Usuarios" &&
							selectedFilterTemp !== "Hora/Grupos" &&
							selectedFilterTemp !== "Por Dias" &&
							selectedFilterTemp !== "Por Horas" && (
								<Form className={styles.typification}>
									<Text className={styles.textTypificacion}>Texto:</Text>
									<div style={{ position: "relative" }}>
										<TextareaAutosize
											value={note}
											name="messageArea"
											onChange={(e) => {
												return setNote(e.target.value);
											}}
											className={styles.inputGroupB}
											rows={1}
										/>
										{note && (
											<Icon
												name="x"
												className={styles.iconCloseInside}
												onClick={() => {
													setNote("");
												}}
											/>
										)}
									</div>
								</Form>
							)}
					</fieldset>
				</div>
				<div className={styles.filtersContainer}>
					<fieldset className={styles.fieldsetChannel}>
						<legend className={styles.legend}>Canales</legend>
						<div className={styles.section}>
							<div className={styles.contDiv}>
								<Checkbox
									className={styles.checkBox}
									name="platformAll"
									checked={platformAll}
									onChange={() => {
										return checkAll("platformfilters");
									}}
								/>
								{!isEmpty(errors.platformfilters) && (
									<Text className={styles.ErrorChannel} color="red">
										{errors.platformfilters}
									</Text>
								)}
								<Text className={styles.sectionTitleText}>Todos</Text>
							</div>

							<div className={styles.sectionContent}>
								<Dropdown
									fluid
									placeholder="Seleccionar"
									multiple
									search
									selection
									value={channelFilters}
									options={channelOptions}
									onChange={handleChannelChange}
									renderLabel={renderLabelPlatforms}
									upward
								/>
							</div>
						</div>
					</fieldset>

					{!isEmpty(groupsData) && (
						<fieldset className={styles.fieldsetGroup}>
							<legend className={styles.legend}>Grupos</legend>
							<div className={styles.contDiv}>
								<Checkbox
									name="groupsAll"
									className={styles.checkBox}
									checked={groupsAll}
									onChange={() => {
										return checkAll("groupsfilters");
									}}
								/>
								<Text className={styles.sectionTitleText}>Todos</Text>
							</div>

							<div className={styles.sectionContent}>
								<Dropdown
									fluid
									onChange={(e, { value }) => {
										return onChangeDropdown(value, "groupsfilters");
									}}
									placeholder="Seleccionar"
									multiple
									search
									selection
									value={groupsfilters}
									options={groupsData}
									renderLabel={renderLabelDepartments}
									upward
								/>
							</div>
						</fieldset>
					)}
				</div>
			</Grid>
		</IKModal>
	);
};

ActionUserCrud.propTypes = {
	onClose: PropTypes.func,
	platforms: PropTypes.object,
	dispatch: PropTypes.func,
	setPlatformfilters: PropTypes.func,
	groupsfilters: PropTypes.array,
	setGroupsfilters: PropTypes.func,
	tagsSelected: PropTypes.array,
	setTagsSelected: PropTypes.func,
	startDate: PropTypes.string,
	setStartDate: PropTypes.func,
	endDate: PropTypes.string,
	setEndDate: PropTypes.func,
	contacts: PropTypes.object,
	setContacts: PropTypes.func,
	agents: PropTypes.array,
	setAgents: PropTypes.func,
	note: PropTypes.string,
	setNote: PropTypes.func,
	options: PropTypes.array,
	setSeletedFilteres: PropTypes.func,
	seletedFilteres: PropTypes.array,
	dateField: PropTypes.string,
	setDateField: PropTypes.func,
	onApplyFilters: PropTypes.func,
	channelFilters: PropTypes.string,
	setChannelFilters: PropTypes.func,
	channels: PropTypes.object,
};

function mapStateToProps({ chats, company, user }) {
	return {
		reply: chats.reply,
		channels: company.channels,
		user,
	};
}

export default connect(mapStateToProps)(ActionUserCrud);
